// @flow
import type { Saga } from 'redux-saga';

import enterEmailJourney from 'shared/utils/segmentActions/enterEmailJourney';

export default function* enterEmailJourneySaga(): Saga<void> {
  enterEmailJourney();
  yield true;
}
